import { Injectable } from '@angular/core';
import { resolve } from 'esri/core/promiseUtils';
import { Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageDialogService {
  public MessageDialogTitle: string = '';
  public MessageDialogMessage: string = '';
  public ShowCancel: boolean = true;
  public $MessageDialogSubject: Subject<boolean> = new Subject<boolean>();
  private $MessageDialogSub: Subscription;

  public OpenDialog: boolean = false;

  OpenMessageDialog(
    MessageDialogTitle,
    MessageDialogMessage,
    ShowCancel: boolean = true
  ) {
    this.OpenDialog = true;
    this.MessageDialogTitle = MessageDialogTitle;
    this.MessageDialogMessage = MessageDialogMessage;
    this.ShowCancel = ShowCancel;
    return new Promise((resolve) => {
      this.$MessageDialogSub = this.$MessageDialogSubject.subscribe((flag) => {
        if (flag) {
          resolve(true);
        } else {
          resolve(false);
        }
        this.$MessageDialogSub.unsubscribe();
        this.OpenDialog = false;
      });
    });
  }
}
